import React from 'react';
import { createHubProvider } from '@xingternal/hub';
export const withHub = (modules = [], config = {}) => {
    const Hub = createHubProvider(modules, config);
    return (WrappedComponent) => {
        const Wrapper = ({ client, ...props }) => {
            return (React.createElement(Hub, { ...{ internalPaths: props.internalPaths, client } },
                React.createElement(WrappedComponent, { ...props })));
        };
        Wrapper.displayName = `withHub([${[
            modules.map((m) => m.name).join(','),
        ]}])(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
        return Wrapper;
    };
};
//# sourceMappingURL=withHub.js.map